// The signed upload URL itself says which cloud minted it: GCS V4 signed URLs are always on
// storage.googleapis.com, while Azure SAS URLs are on the blob host (or a custom domain). The uploader
// branches on this rather than threading a cloud flag through the API, so the upload protocol matches
// the URL. Kept Azure-SDK-free so it can be unit-tested without loading @azure/storage-blob.
export const isGcsSignedUrl = (url: string): boolean => {
    // Pull just the hostname out of the URL without throwing on malformed input (so a non-URL falls
    // through to the Azure default). The character class stops at the first :/?#@, isolating the host.
    try {                                                                                                              
        const host = new URL(url).hostname.toLowerCase();              
        return host === 'storage.googleapis.com' || host.endsWith('.storage.googleapis.com');                                                      
    } catch {                                                                                                          
        return false;                                                                                                  
    } 
};
